import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const MenuList = props => <DefaultDataTable data={props} />;
